<template>
    <div class="eq-pic">
        <div class="icon"
            :class="{'locked' : locked}"                         
        >
            <img v-bind:src="'https://web-resource.17m3.com/cdn/m3-eq/'+ id +'.png'" alt="" srcset="">
            <div class="item-num" v-if="num > 0">{{ num }}</div>
        </div>  
    </div>    
</template>

<style scoped>
.eq-pic{
    position: relative;
    width: 100%;
    height: 100%;
}

.icon{
    position: absolute;
    left: 50%;
    top: 50%;
    width: 100%;
    height: 100%;
    transform: translate(-50%,-50%)
}

.icon.locked::before {
    position: absolute;
    content: "";
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: url("https://web-resource.17m3.com/cdn/m3-eq/ic-lock.png")
      no-repeat 0 0;
    background-size: 100% 100%;
}

.icon .item-num {
    position: absolute;
    content: '';
    right: 2px;
    bottom: 2px;
    background-color: #111322;
    color: #d5d5d3;
    padding: 0 2px;
    font-size: 12px;
    line-height: 1;
    border: 1px solid #a7966b;
}

.icon img{
    width: 100%;
    height: 100%;
}
</style>

<script>
export default {
    name : 'game-item',
    props : {
        id : {
            default : 'A001',
            type : String,
        },
        num : {
            default : 1,
            type : Number,
        },
        locked : {
            default : false,
            type : Boolean,
        }       
    },
}
</script>


// WEBPACK FOOTER //
// src/components/itemview.vue